import * as React from 'react';
import { SVGProps } from 'react';
export const CloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fill="#575E74"
      d="M13.033 11.97a.752.752 0 0 1-1.063 1.062l-3.968-3.97-3.97 3.968a.751.751 0 0 1-1.062-1.062L6.94 8 2.97 4.03a.751.751 0 1 1 1.063-1.062l3.968 3.97 3.97-3.97a.751.751 0 0 1 1.062 1.062L9.064 8l3.969 3.97Z"
    />
  </svg>
);
